import { render, staticRenderFns } from "./Strikethrough.vue?vue&type=template&id=b3f72bda&scoped=true"
import script from "./Strikethrough.vue?vue&type=script&lang=js"
export * from "./Strikethrough.vue?vue&type=script&lang=js"
import style0 from "./Strikethrough.vue?vue&type=style&index=0&id=b3f72bda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f72bda",
  null
  
)

export default component.exports